import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b24d9782")

_pushScopeId("data-v-b24d9782")
const _hoisted_1 = { class: "col-auto" }
const _hoisted_2 = { class: "row items-center full-width" }
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" No Data ")
_popScopeId()


import AppDndList from '@/components/common/ui/AppDndList.vue'


export default _defineComponent({
  props: {
  items: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  headerTextColor: {
    type: String,
    default: 'grey',
  },
},
  emits: ["onChange"] as unknown as undefined,
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(AppDndList, {
    group: "people",
    itemKey: "id",
    items: __props.items,
    onOnChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onChange', $event))),
    textColor: __props.headerTextColor
  }, {
    title: _withId(() => [
      _createVNode("div", {
        class: "row",
        style: [{"align-items":"center"}, { color: __props.headerTextColor }]
      }, [
        _createVNode("div", _hoisted_1, "▼ " + _toDisplayString(__props.title), 1),
        _createVNode("div", {
          class: "col q-ml-sm",
          style: [{"border-top":"1px dashed"}, { borderColor: __props.headerTextColor }]
        }, null, 4)
      ], 4)
    ]),
    "item-content": _withId(({ item }) => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (item.cardType === 'question')
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                size: "md",
                name: "svguse:/icons/story_qa.svg#icon"
              }))
            : (item.cardType === 'goal')
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 1,
                  size: "md",
                  name: "svguse:/icons/story_goal.svg#icon"
                }))
              : (_openBlock(), _createBlock(_component_q_icon, {
                  key: 2,
                  size: "md",
                  name: "svguse:/icons/story_message.svg#icon"
                }))
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_q_item_section, { class: "q-ml-md" }, {
            default: _withId(() => [
              _createVNode(_component_q_item_label, { class: "title" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_item_label, { class: "sub-title" }, {
                default: _withId(() => [
                  _createTextVNode("サイズ: " + _toDisplayString(item.totalUsers), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ])
      ])
    ]),
    empty: _withId(() => [
      _createVNode(_component_q_item, { dense: "" }, {
        default: _withId(() => [
          _createVNode(_component_q_item_section, { size: "" }, {
            default: _withId(() => [
              _createVNode(_component_q_item_label, { class: "title" }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["items", "textColor"]))
}
}

})